import { useMemo } from 'react'

import { createFileRoute, notFound, redirect } from '@tanstack/react-router'
import { z } from 'zod'

import { in_side_types } from '@repo/common/queries/fission_dex'
import { fund_symbols, type FundSymbol } from '@repo/common/queries/products'

import { TradePage } from './trade.index'

export function ensure_trade_fund_symbol({
  fund_symbol: raw_symbol,
}: {
  fund_symbol: string
}): {
  fund_symbol: FundSymbol
} {
  const fund_symbol = raw_symbol.toUpperCase() as FundSymbol
  if (!fund_symbols.includes(fund_symbol)) {
    throw notFound()
  }
  return { fund_symbol }
}

const limit_order_search_schema = z.object({
  price: z.union([z.undefined(), z.number()]).catch(undefined),
  tick: z.union([z.undefined(), z.number()]).catch(undefined),
  sell: z.preprocess(
    (value) => (value != null ? String(value).toUpperCase() : value),
    z.union([z.undefined(), z.enum(in_side_types)]).catch(undefined),
  ),
})

export const Route = createFileRoute('/_app/trade/$fund_symbol/limit_order')({
  component: TradeFundSymbolLimitOrderPricePage,
  onError: () => redirect({ throw: true, to: '/trade' }),
  params: {
    parse: ensure_trade_fund_symbol,
  },
  validateSearch: (search) => limit_order_search_schema.parse(search),
})

function TradeFundSymbolLimitOrderPricePage() {
  const { price, tick, sell } = Route.useSearch()

  const limit_order_starting_values = useMemo(
    () => ({
      starting_price: price,
      starting_tick: tick,
      starting_in_side: sell,
    }),
    [price, sell, tick],
  )

  return (
    <TradePage
      fund_symbol="TOKX"
      starting_tab="limit"
      limit_order_starting_values={limit_order_starting_values}
    />
  )
}
